const codeVerificationInit = () => {
  const form = document.getElementById('code_verification_form')
  const inputs = form.querySelectorAll('.code-input')
  const codeField = form.querySelector('input[name="code"]')

  const resetInputs = () => {
    inputs.forEach((element) => {
      element.value = ''
    })
    inputs[0].focus()
    codeField.value = ''
  }

  const fillInputs = (code) => {
    Array.from(code).forEach((char, index) => {
      if (index < inputs.length) {
        inputs[index].value = char
      }
    })
    codeField.value = code
  }

  const handlePaste = (pastedText) => {
    if (pastedText.length === 6) {
      fillInputs(pastedText.toUpperCase())
      form.requestSubmit()
    }
  }

  inputs.forEach((element, index) => {
    element.addEventListener('input', (e) => {
      element.value = element.value.toUpperCase()
      if (index === 0 && e.inputType === 'insertFromPaste') {
        handlePaste(element.value)
        return
      }

      if (element.value.length === 1 && index < inputs.length - 1) {
        inputs[index + 1].focus()
      }

      codeField.value = Array.from(inputs)
        .map((input) => input.value)
        .join('')

      if (codeField.value.length === 6) {
        form.requestSubmit()
      }
    })

    element.addEventListener('keydown', (e) => {
      if (e.key === 'Backspace' && !element.value && index > 0) {
        e.preventDefault()
        inputs[index - 1].focus()
      }
    })

    if (index === 0) {
      element.addEventListener('paste', (e) => {
        e.preventDefault()
        const pastedText = e.clipboardData.getData('text').trim()
        handlePaste(pastedText)
      })
    }
  })

  if (document.querySelector('.alert-danger')) {
    resetInputs()
  }
}

window.codeVerificationInit = codeVerificationInit
